import {
    Table,
    TableSectionsData
} from "@/libraries/design/patterns/table/src/table";

import { transformContentfulDataToTableData } from "./utils";

export interface RelevantPlan {
    fields?: {
        planTitleExternal?: string;
        planTitleInternal?: string;
    };
}

export interface FeatureAdditionalInformation {
    fields?: {
        featureAdditionalInformation?: string;
        relevantPlan: Array<RelevantPlan>;
    };
}

export interface FeatureDataContent {
    nodeType:
        | "text"
        | "hyperlink"
        | "paragraph"
        | "unordered-list"
        | "list-item";
    value?: string;
    content?: FeatureDataContent[];
    data?: {
        uri?: string;
    };
}

export interface FeatureData {
    fields: {
        description?: string;
        featureNameExternal?: string;
        featureNameInternal?: string;
        relevantUrl?: string;
        featureAdditionalInformation?: FeatureAdditionalInformation[];
        relevantPlan?: RelevantPlan[];
        callOut?: string;
    };
}

// expected contentful data structure
export interface ContentfulFeature {
    fields: {
        featureGroupTitleExternal: string;
        featureGroupTitleInternal?: string;
        features?: FeatureData[];
    };
}

export interface UniformPricingTableProps {
    tableData: ContentfulFeature[];
    planTitles: {
        fields: {
            planTitleExternal: string;
        };
    }[];
}

const UniformPricingTable = (props: UniformPricingTableProps) => {
    const { tableData = [], planTitles } = props;

    const effectivePlanTitles = planTitles.map(
        ({ fields }) => fields.planTitleExternal
    );

    const transformedSections = transformContentfulDataToTableData(
        tableData,
        effectivePlanTitles
    );

    return (
        <Table
            header={{
                titles: ["", ...effectivePlanTitles]
            }}
            sections={transformedSections as TableSectionsData}
        />
    );
};

export default UniformPricingTable;
